<div class="sw-cms-el-config-moorl-download-list">
    <sw-cms-mapping-field
        v-model:config="element.config.downloads"
        entity="media"
        value-types="entity"
        :label="$tc('sw-cms.elements.moorl-download-list.label.downloads')"
    >
        <sw-entity-multi-select
            class="sw-cms-el-config-download-slider__downloads"
            v-model:entityCollection="downloadCollection"
            @update:entity-collection="onDownloadsChange"
            labelProperty="fileName"
            :context="downloadSearchContext"
            :criteria="downloadSearchCriteria"
        />
    </sw-cms-mapping-field>
    <moorl-select-field
        :label="$tc('sw-cms.elements.moorl-download-list.label.layout')"
        v-model:value="element.config.layout.value"
        :customSet="elementOptions.layout"
    />
    <mt-text-field
        v-model="element.config.emptyText.value"
        :label="$tc('sw-cms.elements.moorl-download-list.label.emptyText')"
    />
</div>